import { z } from 'zod';
import { isNil } from 'lodash-es';

export const TYRE_SPEC_ENUM = {
  ECO: {
    DISABLED: 0,
    ENABLED: 1,
  },
  ELECTRIC: {
    DISABLED: 0,
    RECOGNIZED: 1,
    COMPATIBLE: 2,
  },
} as const;

export const getListQuantitySchema = (
  availableQuantities: Array<{ quantity: number; isParent: boolean }>,
  minimumQuantity: number,
  requestedQuantity: number,
) =>
  z.object({
    quantity: z
      .array(z.coerce.number<number>().optional())
      .superRefine((quantities, ctx) => {
        quantities.forEach((quantity, offerIndex) => {
          const offer = availableQuantities[offerIndex];
          // technical errors
          if (isNil(quantity) || isNil(requestedQuantity) || isNil(offer)) {
            ctx.addIssue({
              code: 'custom',
              message: 'app.purchase.cart.errors.invalid_quantity',
              path: [offerIndex],
              fatal: true,
            });
            return;
          }
          const maximumQuantity = offer.quantity;
          const isParent = offer.isParent;

          // business errors
          if (
            (!isParent && quantity > requestedQuantity) ||
            quantity > maximumQuantity ||
            quantity < minimumQuantity
          ) {
            ctx.addIssue({
              code: 'custom',
              message:
                'app.purchase.search_page.errors.change_requested_quantity',
              path: [offerIndex],
              fatal: true,
            });
            return;
          }
        });
      }),
  });
